"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { Plus } from "lucide-react";

export default function CreditBalance({ initialCredits }: { initialCredits: number }) {
  const [credits, setCredits] = useState(initialCredits);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await fetch("/api/profile");
        if (res.ok) {
          const data = await res.json();
          if (data.credits !== undefined) setCredits(data.credits);
        }
      } catch {}
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Link href="/subscribe" className="flex items-center gap-1.5 h-8 px-3 rounded-md bg-neutral-900 border border-neutral-800 hover:border-green-800/60 transition">
      <Plus className="w-3 h-3 text-green-500" />
      <span className="text-[12px] font-bold font-mono text-green-400">{credits.toLocaleString()}</span>
    </Link>
  );
}
